<tc-chip-input
        #costing_type_search_chip_input
        (cancelEmitter)="onCancel($event)"
        (chipListEmitter)="onChipListDisplay($event)"
        (onfocus)="onFocus($event)"
        (searchEmitter)="onCostingTypeSearch($event)"
        [chisForDisplay]="displayChipsArr"
        [inputAuthConfigComponent]="null"
        [isChipListOptionAvail]="true"
        [isDataLoaded]="isDataLoaded"
        [isFocus]="isFocus"
        [isSearchBarStyleNotAvailable]="isSearchBarStyleNotAvailable"
        [isTriggerSearch]="isTriggerSearch"
        [placeHolderText]="placeHolderText">
</tc-chip-input>
<div class="clearfix"></div>
